module.exports = __webpack_public_path__ + "static/media/kmlHeader.c6560d3d.jpg";